import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
const bluOceanPhotos = [{
  src: 'https://cdn.magicpatterns.com/uploads/s5KBpYMF9FCGQWRcrYkBdU/WhatsApp_Image_2026-06-16_at_14.38.01.jpg',
  alt: 'Snorkeling over a coral reef full of tropical fish'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/jybBhmRLDUa5yoRQF5y3F7/IMG-20250904-WA0046_-_copia.jpg',
  alt: 'Jet ski experience'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/a1g5GonkVhvtFQstmVmPux/IMG-20251111-WA0027_-_copia.jpg',
  alt: 'Group enjoying sunset on the boat'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7kp8Cvuk5eqA1jfRj71oHP/IMG-20250630-WA0006_-_copia.jpg',
  alt: 'Boats and floating mat at the cay'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/sUgAP8fYArxoMZxrS228QB/IMG-20250702-WA0078_-_copia.jpg',
  alt: 'Guests boarding the private boat'
}];
const rainforestPhotos = [{
  src: 'https://cdn.magicpatterns.com/uploads/4dpgXqyWADdEHorU6tRZpm/WhatsApp_Image_2026-06-15_at_15.59.29.jpg',
  alt: 'Group exploring giant rainforest tree roots'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3R8xdNujatbL5ZK47zg7NP/WhatsApp_Image_2026-06-15_at_15.59.39.jpg',
  alt: 'Group at a hidden El Yunque waterfall'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3SqDwXhXq1fzNAi5DRkafu/WhatsApp_Image_2026-06-15_at_15.59.40.jpg',
  alt: 'Climbing the rope through rainforest rocks'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cwZUhy9JdoURvGryznoZSR/WhatsApp_Image_2026-06-15_at_15.59.43_(1).jpg',
  alt: 'Natural pool under the cascades'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/9Urz3C6rTCzLh5EaQaN3r2/WhatsApp_Image_2026-06-15_at_15.59.43_(2).jpg',
  alt: 'Relaxing by the waterfall after the hike'
}];
interface GalleryRowProps {
  title: string;
  subtitle: string;
  photos: {
    src: string;
    alt: string;
  }[];
  accent: string;
}
function GalleryRow({
  title,
  subtitle,
  photos,
  accent
}: GalleryRowProps) {
  return <div data-id="element-135">
      <div className="flex items-baseline gap-3 mb-5 px-1" data-id="element-136">
        <h3 className="font-heading text-2xl md:text-3xl font-bold text-ocean-dark" data-id="element-137">
          {title}
        </h3>
        <span className={`text-sm font-medium ${accent}`} data-id="element-138">{subtitle}</span>
      </div>
      <div className="flex gap-4 overflow-x-auto no-scrollbar pb-4 -mx-4 px-4 snap-x snap-mandatory" data-id="element-139">
        {photos.map((photo, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.08
      }} className="relative flex-shrink-0 w-72 h-80 sm:w-80 sm:h-96 rounded-2xl overflow-hidden group snap-start shadow-lg" data-id="element-140">
            <img src={photo.src} alt={photo.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-141" />
            <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-142" />
          </motion.div>)}
      </div>
    </div>;
}
export function Gallery() {
  const {
    t
  } = useLanguage();
  return <section id="gallery" className="py-24 bg-white overflow-hidden" data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <div className="text-center mb-16" data-id="element-145">
          <h2 className="text-4xl font-heading font-bold text-ocean-dark mb-4" data-id="element-146">
            {t.nav.gallery}
          </h2>
          <div className="w-24 h-1 bg-turquoise mx-auto rounded-full" data-id="element-147" />
        </div>

        <div className="space-y-16" data-id="element-148">
          <GalleryRow title="Blu Ocean Tours" subtitle={t.nav.boat} photos={bluOceanPhotos} accent="text-turquoise" data-id="element-149" />
          <GalleryRow title="Sweet & Salty" subtitle={t.nav.rainforest} photos={rainforestPhotos} accent="text-rainforest" data-id="element-150" />
        </div>
      </div>
    </section>;
}